import { render, staticRenderFns } from "./zjgg.vue?vue&type=template&id=37de744e&scoped=true&"
import script from "./zjgg.vue?vue&type=script&lang=js&"
export * from "./zjgg.vue?vue&type=script&lang=js&"
import style0 from "./zjgg.vue?vue&type=style&index=0&id=37de744e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37de744e",
  null
  
)

export default component.exports